import React from "react";
import AuditPanel from "src/pages/Audits/Panel/Index";
import Standards from "src/pages/Audits/Standards";

import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/audit/standards" key="standards" exact component={Standards} isPrivate />,
	<RoutePrivate path="/audit/panel" key="auditpanel" exact component={AuditPanel} isPrivate />,
	<RoutePrivate path="/audit/panel/:auditId" permissionPath="/audit/panel" key="auditpanelauditId" exact component={AuditPanel} isPrivate />
];
